import { Organization } from 'src/app/core/model/organization';

export interface Chatbot
{
  baseUrl: string;
  appId: string;
  hash: string;
  organization: string;
}

export class User
{
  public id: any;
  public userName: string;
  public username: string;
  public firstName: string;
  public lastName: string;
  public fullName: string;
  public name: string;
  public department: string;
  public departmentName: string;
  public organization: string;
  public organizationName: string;
  public email: string;
  public mobile: string;
  public differentAuthMethodAllowed: boolean;
  public token: string;
  public qrCode: any;
  public password: string;
  public photo: any;
  public enabled = true;
  public preferredLanguage = 'English';
  public role: string;
  public roleName: string;
  public inRegistration = false;
  /** Present when loaded from group member light API or full user payloads. */
  public deleted?: boolean;
  public servicesAccount = false;
  public linkedFHIRUser = false;
  public isEHROnlyAccess = false;
  public phoneNumber: string;
  public lastLoggedOn: Date;
  public authenticated: boolean;
  public twoFa: boolean;
  public changePassword: boolean;
  public allowedRoles = [];
  public allowedOrganizations = [];
  public chatbot: Chatbot;
  public organizationId: number;
  public temporarilyDisabled = false;
}

export class Group
{
  public id: number;
  public version: number;
  public name: string;
  public active = true;
  public description: string;
  /** Present on full group loads; omitted on {@code dataLoad=listOnly} list rows. */
  public users?: User[];
  public organization: Organization;
  /** Set by API for list-only rows (server aggregate). */
  public userCount?: number;
  public organizationName?: string;
  public organizationId?: number;
}

/** Response from {@code GET /group/{id}?dataLoad=light}. */
export interface GroupDetailLight
{
  id: number;
  version: number;
  name: string;
  description: string;
  active: boolean;
  organizationId: number | null;
  organizationName: string | null;
  /** Present on light PUT response. */
  userCount?: number;
}

/** Row from {@code GET /users/groups/{groupId}}. */
export interface GroupMemberLight
{
  id: number;
  firstName: string | null;
  lastName: string | null;
  name: string | null;
  fullName: string | null;
  username: string | null;
  enabled: boolean;
  deleted: boolean;
  inRegistration: boolean | null;
  /** Present when {@code GET /users?dataLoad=light&includeUserPhoto=true}. */
  photo?: string | null;
}
